// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { Grid, Box, Button, Paper, Typography } from "@mui/material";
import DefaultTable from "./DefaultTable";
import HomeIcon from '@mui/icons-material/Home';
import * as Types from "../data/utils/types";

interface CaseStateViewProps {
    setCaseState: (id: string) => void;
    state: string;
    data: any;
    loading: boolean;
    error: any;
    page: number;
    setPage: (page: number) => void;
    rowsPerPage: number;
    setRowsPerPage: (rowsPerPage: number) => void;
}

export default function CaseStateView(caseViewProps: CaseStateViewProps): JSX.Element {


    const colNameArray = ["Number", "Case ID", "Short Description", "Case Type", "Priority", "State"];
    const colAttributeArray = ["number", "caseId", "shortDescription", "caseType", "priority", "state"];

    const handleAccountTableRowClick = (rowData: Types.ProjectDetails) => {
      window.open(`/support/cases/${rowData.number}`,'_blank');
    };

    function handleHomeClick(): void {
        caseViewProps.setCaseState("");
    }

    return (
        <>
            <Grid container >
                <Grid item xs={12} >
                    <Box display="flex" justifyContent="flex-start" p={1}>
                        <Button variant="contained"
                            sx={{
                                color: 'white',
                                ':hover': {
                                    bgcolor: '#e96900',
                                    borderColor: 'primary.main',
                                    color: 'white',
                                }
                            }}
                            onClick={handleHomeClick} startIcon={<HomeIcon />}
                        >
                            Home
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            <Paper>
                <Grid container >
                    <Grid item xs={4} >
                    </Grid>
                    <Grid item xs={4}  >
                        <Typography p={1} align="center" gutterBottom variant="h4" >
                            {caseViewProps.state} Cases
                        </Typography>
                    </Grid>
                    <Grid item xs={4} >
                    </Grid>
                </Grid>
                <DefaultTable
                    data={caseViewProps.data}
                    loading={caseViewProps.loading}
                    error={caseViewProps.error}
                    page={caseViewProps.page}
                    setPage={caseViewProps.setPage}
                    rowsPerPage={caseViewProps.rowsPerPage}
                    setRowsPerPage={caseViewProps.setRowsPerPage}
                    colNameArray={colNameArray}
                    colAttributeArray={colAttributeArray}
                    handleRowClick={handleAccountTableRowClick}
                />
            </Paper>
        </>
    )
}
